<template>
    <VJoyDialog
        ref="abortBatchValidationDialog"
        open
        confirm-text="Confirm"
        cancel-text="Cancel"
        data-testid="abort-batch-creation-dialog"
        @dialog:hide="emit('close:dialog')"
        @dialog:confirm="emit('confirm:action')"
    >
        <template #dialog-header>
            {{ t(`projectclient.expenses.validation.summary.dialog.${origin}.title`) }}
        </template>
        <template #dialog-body>
            {{ t(`projectclient.expenses.validation.summary.dialog.${origin}.description`) }}
        </template>
    </VJoyDialog>
</template>

<script setup lang="ts">
    import {useTemplateRef} from 'vue';
    import {useTranslation} from '#imports';
    import {VJoyDialog} from '@maltjoy/core-vue';
    import type {FunnelOrigin} from '../types';

    const {t} = useTranslation();

    const abortBatchValidationDialog = useTemplateRef('abortBatchValidationDialog');

    defineProps<{
        origin: FunnelOrigin;
    }>();

    const emit = defineEmits<{
        'close:dialog': [];
        'confirm:action': [];
    }>();
</script>
